<template>
  <b-modal
    id="xoa-nguoi-dung"
    centered
    size="md"
    header-class="border-bottom-none"
    footer-class="border-top-none"
  >
    <div class="font-size-14">
      <h4 class="center">Bạn có chắc chắn xóa người dùng này khỏi vai trò?</h4>
    </div>
    <template v-slot:modal-footer>
      <div class="w-100">
        <base-button :button="BO_QUA_BUTTON_LABEL" class="btn btn-line float-right" @click="hideModal()">
          {{ BO_QUA_BUTTON_LABEL }}
        </base-button>
        <base-button
          class="btn btn-main ml-2 float-right"
          button="Đồng ý"
          @click="xoaDanhSachNguoiDungTrongVaiTro()"
        >
          ĐỒNG Ý
        </base-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { ROUTE_NAME, BO_QUA_BUTTON_LABEL } from "@/constants/constants";

export default {
  name: "XoaNguoiDungModal",
  data() {
    return {
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      ROUTE_NAME: ROUTE_NAME
    };
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("xoa-nguoi-dung");
    },
    xoaDanhSachNguoiDungTrongVaiTro() {
      this.$bvModal.hide("xoa-nguoi-dung");
      this.$emit("xoaDanhSachNguoiDungTrongVaiTro");
    }
  }
};
</script>
